import { SearchBarDispatcher as SourceSearchBarDispatcher } from 'SourceStore/SearchBar/SearchBar.dispatcher';
import SearchQuery from 'Query/Search.query';

import { updateLoadStatus } from './SearchBar.action';

export class SearchBarDispatcher extends SourceSearchBarDispatcher {
    prepareRequest(options, dispatch) {
        dispatch(updateLoadStatus(true));

        return SearchQuery.getQuery({
            ...options
        });
    }
}

export default new SearchBarDispatcher();
